/** `bump-arcade/sewer-duel` — the 1983 sewer arena as a two-player versus
 * match (Mario Bros' 2P game played to win): both plumbers share the arena
 * and its pests against the clock, and the higher score at the bell wins. A
 * timed match rather than a race to a score: the clock always reaches the
 * phases where every pest kind appears (the fighter-flies come at ~1.5 min),
 * so every one of the game's art slots is seen. A versus variant of
 * {@link SEWER_1983_TEMPLATE} by data (variants.ts). */
import { SEWER_1983_TEMPLATE } from './bumpArcadeMario.js';
import { versusVariantOf } from './variants.js';

// Pure: a bundle that never reads the duel (a Tank sandbox) drops it.
export const SEWER_DUEL_TEMPLATE = /*#__PURE__*/ versusVariantOf(SEWER_1983_TEMPLATE, {
  id: 'bump-arcade/sewer-duel',
  title: '1983 sewer bump duel',
  pitch: 'Two plumbers share one sewer arena against the clock: bump pests from below and kick them for points; the higher score at the bell wins.',
  disclosure: {
    coreVerbs: ['run', 'jump', 'bump'],
    mechanics: [
      'Two players share a single-screen arena of platform tiers whose left and right edges wrap around.',
      'Pests emerge from the upper pipes; jumping into a platform from below flips the pest standing on it.',
      'Touching a flipped pest kicks it away for a rising score chain — whoever kicks it scores.',
      'A shared POW block hit from below flips every grounded pest.',
      'Touching an upright pest costs a life; a player out of lives is out of the match.',
    ],
    controls: 'Move left or right; jump to bump the platform above you. Touch a flipped pest to kick it.',
    winCondition: 'The higher score when the match clock runs out wins.',
  },
  rival: { kind: 'luigi', role: 'the second plumber, in green overalls and a green cap', palette: 4 },
  objective: { win: 'most-at-time', count: 30 * 150 },
  requiredEvents: ['bump', 'flip', 'kick', 'defeat'],
  // The match is won on bumps and kicks; the POW block is a shared bonus
  // there, not load-bearing (its stub check passes).
  signatureModules: ['rule.bumpFromBelow', 'rule.vulnerableWindow', 'rule.kicker', 'world.pipes', 'flow.director'],
  // Match length in ticks: two to five minutes (two minutes still reaches every pest kind).
  objectiveTunables: [{ path: '/globals/flow.objective/count', min: 30 * 120, max: 30 * 300, integer: true }],
});
